import { toCanvas } from "html-to-image";
import Plotly from "plotly.js/dist/plotly-myPlotly.js";
import React, { RefObject } from "react";
import { PlotRefType } from "../ChartHOC";
import { legendChartFontParam, titleChartFontParam } from "../ChartPngParam";

// The size Plotly renders a downloaded plot at.
export const PLOT_IMAGE_SIZE = { width: 1232, height: 586 };

export const setPlotlyImage = async (
  plotRef: React.MutableRefObject<PlotRefType>
) => {
  if (!plotRef?.current) {
    return;
  }
  const chart = await Plotly.toImage(plotRef.current.el, {
    format: "svg",
    ...PLOT_IMAGE_SIZE,
  });

  const createImageElement = new Image();
  createImageElement?.setAttribute("src", chart);

  await createImageElement.decode();

  return createImageElement;
};

export const drawTitleChartBlock = async ({
  titleBlock,
  ctx,
  canvasTotalWidth,
  titleMarginTop,
}: {
  titleBlock?: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
  canvasTotalWidth: number;
  titleMarginTop: number;
}) => {
  if (titleBlock && titleBlock.height !== 0) {
    ctx.drawImage(
      titleBlock,
      (canvasTotalWidth - titleBlock.width) / 2,
      titleMarginTop
    );
  }
};

export const drawLegendBlock = async ({
  legendBlock,
  ctx,
  titleBlockHeight,
  marginLegendTop,
  canvasTotalWidth,
}: {
  legendBlock?: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
  titleBlockHeight: number;
  marginLegendTop: number;
  canvasTotalWidth: number;
}) => {
  if (legendBlock && legendBlock.height !== 0) {
    ctx.drawImage(
      legendBlock,
      (canvasTotalWidth - legendBlock.width) / 2,
      titleBlockHeight + marginLegendTop * 1.5
    );
  }
};

export const drawPlotlyBlock = async ({
  plotlyBlock,
  ctx,
  canvasTotalWidth,
  titleBlockHeight,
  legendBlockHeight,
  canvasTotalHeight,
}: {
  plotlyBlock?: HTMLImageElement;
  ctx: CanvasRenderingContext2D;
  canvasTotalWidth: number;
  titleBlockHeight: number;
  legendBlockHeight: number;
  canvasTotalHeight: number;
}) => {
  if (plotlyBlock) {
    ctx.drawImage(
      plotlyBlock,
      0,
      0,
      canvasTotalWidth,
      canvasTotalHeight,
      0,
      titleBlockHeight + legendBlockHeight * 1.2,
      canvasTotalWidth,
      canvasTotalHeight
    );
  }
};

export const canvasTitleBlock = async ({
  titleDOM,
}: {
  titleDOM: RefObject<HTMLDivElement>;
}) => {
  if (!titleDOM?.current) return undefined;

  return toCanvas(titleDOM.current, {
    pixelRatio: 1,
    fontEmbedCSS: titleChartFontParam,
  });
};

export const canvasLegendBlock = async ({
  legendDOM,
}: {
  legendDOM: RefObject<HTMLDivElement>;
}) => {
  if (!legendDOM?.current) return undefined;

  return toCanvas(legendDOM.current, {
    pixelRatio: 1,
    fontEmbedCSS: legendChartFontParam,
  });
};
